<div appClickOutside (clickOutside)="onOutsideClick($event, j)">
  <a
    id="dropdownMenuButton"
    type="button"
    data-bs-toggle="dropdown"
    data-bs-flip="true"
    aria-haspopup="true"
    aria-expanded="false"
    (click)="openOptions(j, $event)"
    style="margin-bottom: 7px"
  >
    <img *ngIf="isGroupButton" src="assets/svgIcon/dots.svg" width="16px" style="margin-left: 8px;"/>
    <div *ngIf="!isGroupButton" style="font-weight: bolder">...</div>
  </a>
  <div
    style="position: fixed; right: 87px !important;"
    class="dropdown-menu end-0"
    [class.show]="showOption[j]"
    aria-labelledby="dropdownMenuButton"
    #dropDownOptionsMenu
  >
    <a class="dropdown-item p-0" *ngIf="options">
      <ul class="list-group list-group-flush">
        <li
          class="list-group-item list-group-item-action media"
          *ngFor="let option of options; let i = index"
          type="button"
          (click)="onClickEmitOption(option, value)"
          [class.disabled]="option.disabled"
        >
          <div class="d-flex">
            <i
              [class]="option.icon"
              class="m-r-5 m-y-3"
              style="margin-top: 3px"
            ></i>
            <a
              style="padding-right: 10px"
            >
              {{ option.name | translate }}
            </a>
          </div>
        </li>
      </ul>
    </a>
  </div>
</div>
